<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Leere Featuresysteme löschen' | translate }}</div>
  <dx-switch [(value)]="deleteFeatureSystems"></dx-switch>
</div>
